"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNoNulls = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var sdk_model_1 = require("@gooddata/sdk-model");
function assertNoNulls(elements) {
    var rawData = sdk_model_1.isAttributeElementsByRef(elements) ? elements.uris : elements.values;
    ts_invariant_1.default(rawData.every(function (item) { return item !== null; }), "Nulls are not supported as attribute element values or uris on bear");
}
exports.assertNoNulls = assertNoNulls;
//# sourceMappingURL=utils.js.map